import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {NameGeneratorProperty} from '@domain/custom-settings/name-generation-property';
import {ProductionOrderCustomSettings} from '@domain/production-schedule/custom-settings/production-order-custom-settings';
import {ProductionOrderNameGenerationView} from '@domain/production-schedule/custom-settings/production-order-name-generation-view.interface';
import {map, Observable} from 'rxjs';
import {CustomSettingsRepository} from '../custom-settings-repository.interface';

@Injectable({providedIn: 'root'})
export class HttpProductionOrdersCustomSettingsService implements CustomSettingsRepository<ProductionOrderCustomSettings, ProductionOrderNameGenerationView> {
  public constructor(
    private readonly httpClient: HttpClient,
    private readonly backendConfiguration: BackendConfiguration
  ) {}

  public get(): Observable<ProductionOrderCustomSettings> {
    return this.httpClient.get(this.baseUrl()).pipe(map((json: any) => ProductionOrderCustomSettings.fromJSON(json)));
  }

  public save(customSettings: ProductionOrderCustomSettings): Observable<void> {
    return this.httpClient.post<void>(this.baseUrl(), customSettings.toJSON());
  }

  public getNameGenerationProperties(): Observable<NameGeneratorProperty[]> {
    return this.httpClient.get(`${this.baseUrl()}/name-generation-properties`).pipe(map((json: any[]) => json.map((jsonElement: any) => NameGeneratorProperty.fromJSON(jsonElement))));
  }

  public generateName(entity: ProductionOrderNameGenerationView): Observable<string> {
    return this.httpClient.post<string>(`${this.baseUrl()}/generate-name`, entity);
  }

  public getPathLabelNameGenerationProperties(): Observable<NameGeneratorProperty[]> {
    return this.httpClient.get(`${this.baseUrl()}/path-label/name-generation-properties`).pipe(map((json: any[]) => json.map((jsonElement: any) => NameGeneratorProperty.fromJSON(jsonElement))));
  }

  public hasAlreadyAdjusted(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.baseUrl()}/has-already-adjusted`);
  }

  private baseUrl(version: number = 2): string {
    return `${this.backendConfiguration.getProductionOrderEndpoint(version)}production-orders/carpet/custom-settings`;
  }
}
